// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z\"/> </svg> ";
// Exports
module.exports = code;